export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/more-icon.svg?8d6baef8ffbb2a52fbd89039a9b2e8ab";